import * as $ from 'jquery';
import CookieHandler from './../modules/component/cookieHandler';

export default class FlashInfoModel {

    protected id:number;
    protected bg:string;
    protected counter_color:string;
    protected counter_show:string;
    protected counter_bg:string;
    protected counter_unit:string;
    protected begin_time:Date;
    protected end_time:Date;
    protected store_id:number;
    protected text:string;
    protected title:string;
    protected link:string;

    protected jQueryElement:any;
    protected jQueryContent:any;
    protected calendarTestDays1:any;
    protected calendarTestDays2:any;
    protected calendarTestDaysUnit:any;

    protected calendarTestHours1:any;
    protected calendarTestHours2:any;
    protected calendarTestHoursUnit:any;

    protected calendarTestMinutes1:any;
    protected calendarTestMinutes2:any;
    protected calendarTestMinutesUnit:any;

    protected calendarTestSeconds1:any;
    protected calendarTestSeconds2:any;
    protected calendarTestSecondsUnit:any;

    protected closeBtn:any;
    protected textHtml:any;
    protected closedFlashinfo:string;
    protected interval:any;

    /**
     * Constructor
     *
     * @param config
     */
    constructor(config) {
        this.id = config.id;
        this.bg = config.bg;
        this.counter_color = config.counter_color;
        this.counter_show = config.counter_show;
        this.counter_unit = config.counter_unit;
        this.counter_bg = config.counter_bg;
        let tStart = config.begin_time.toString().split(/[- :]/);
        this.begin_time = new Date(tStart[0], tStart[1]-1, tStart[2], tStart[3], tStart[4], tStart[5]);
        let tEnd = config.end_time.toString().split(/[- :]/);
        this.end_time = new Date(tEnd[0], tEnd[1]-1, tEnd[2], tEnd[3], tEnd[4], tEnd[5]);
        this.store_id = config.store_id;
        this.text = config.text;
        this.title = config.title;
        this.link = config.link;
        this.closedFlashinfo = 'flashinfo-' + this.id + '-closed';

        this.buildHtml(); 
        this.bindEvents();

    }

    /**
     * Get primary key of the flash info
     *
     * @returns {number}
     */
    getId() {
        return this.id;
    }

    /**
     * Build Html of flash info
     */
    buildHtml() {
        this.jQueryElement = $('<div>').addClass('flashinfo').attr('data-id', this.id).css('background', this.bg);

        if(this.link) {
            this.jQueryContent = $('<a>').addClass('flashinfo-content').attr('href', this.link).appendTo(this.jQueryElement);
        } else {
            this.jQueryContent = $('<div>').addClass('flashinfo-content').appendTo(this.jQueryElement);
        }

        this.textHtml = $('<div>').addClass('text').html(this.text).appendTo(this.jQueryContent);

        if (this.counter_show == '1') {
            let counter = $('<div>').addClass('counter').appendTo(this.jQueryContent);
            let time = $('<span>').addClass('time').appendTo(counter);
            let css = {
            'color': this.counter_unit,
            'background': this.counter_bg
        };
            this.calendarTestDays1 = $('<span>').addClass('calendar-days-1').css(css).appendTo(time);
            this.calendarTestDays2 = $('<span>').addClass('calendar-days-2').css(css).appendTo(time);
            this.calendarTestDaysUnit = $('<span>').addClass('unite').css('color', this.counter_color).text(' j').appendTo(time);

            this.calendarTestHours1 = $('<span>').addClass('calendar-hours-1').css(css).appendTo(time);
            this.calendarTestHours2 = $('<span>').addClass('calendar-hours-2').css(css).appendTo(time);
            this.calendarTestHoursUnit = $('<span>').addClass('unite').css('color', this.counter_color).text(' h').appendTo(time);

            this.calendarTestMinutes1 = $('<span>').addClass('calendar-minutes-1').css(css).appendTo(time);
            this.calendarTestMinutes2 = $('<span>').addClass('calendar-minutes-2').css(css).appendTo(time);
            this.calendarTestMinutesUnit = $('<span>').addClass('unite').css('color', this.counter_color).text(' m').appendTo(time);

            this.calendarTestSeconds1 = $('<span>').addClass('calendar-seconds-1').css(css).appendTo(time);
            this.calendarTestSeconds2 = $('<span>').addClass('calendar-seconds-2').css(css).appendTo(time);
            this.calendarTestSecondsUnit = $('<span>').addClass('unite').css('color', this.counter_color).text(' s').appendTo(time);
        }

        this.closeBtn = $('<span>').addClass('close-btn').append('<i class="i i-cross"></i>').appendTo(this.jQueryElement);
    }

    /**
     * Clear all events
     */
    clearEvents() {
        if (this.interval) {
            clearInterval(this.interval);
        }

        this.closeBtn.unbind('click', () => {
            this.close()
        });
    }

    /**
     * Bind all events
     */
    bindEvents() {
        var instance = this;

        this.handleBanner();

        if (this.isEnable()) {
            this.interval = setInterval(() => instance.handleBanner(), 1000);
        }

        this.closeBtn.click(() => {
            this.close()
        });
    }

    /**
     * Check if banner is active now
     */
    isEnable() {
        if (sessionStorage.getItem(this.closedFlashinfo) === '1') {
            return false;
        }

        let cookieHandler = new CookieHandler;
        let previewDate:any = cookieHandler.getCookieByName('preview');
        let date:any = previewDate ? new Date(previewDate * 1000) : new Date();

        return (date >= this.begin_time && date < this.end_time);
    }

    /**
     * Calculate the delay and show/hide the banner
     */
    handleBanner() {
        
        var now = new Date();

        if (this.isEnable()) {

            if (this.counter_show == '1') {
                let timeDiff:any = Math.abs(this.end_time.getTime() - now.getTime());

                let diffDays:any = (timeDiff / (1000 * 3600 * 24)).toString().split('.')[0];
                let diffHours:any = (((timeDiff / (1000 * 3600 * 24)) - diffDays) * 24).toString().split('.')[0];
                let diffMinutes:any = (((((timeDiff / (1000 * 3600 * 24)) - diffDays) * 24) - diffHours) * 60).toString().split('.')[0];
                let diffSeconds:any = (((((((timeDiff / (1000 * 3600 * 24)) - diffDays) * 24) - diffHours) * 60)- diffMinutes) * 60).toString().split('.')[0];

                diffDays = (diffDays < 10) ? ('0' + diffDays) : '' + diffDays;
                diffHours = (diffHours < 10) ? ('0' + diffHours) : '' + diffHours;
                diffMinutes = (diffMinutes < 10) ? ('0' + diffMinutes) : '' + diffMinutes;
                diffSeconds = (diffSeconds < 10) ? ('0' + diffSeconds) : '' + diffSeconds;

                diffDays = diffDays.split('');
                diffHours = diffHours.split('');
                diffMinutes = diffMinutes.split('');
                diffSeconds = diffSeconds.split('');


                this.calendarTestDays1.html(diffDays[0]);
                this.calendarTestDays2.html(diffDays[1]);

                this.calendarTestHours1.html(diffHours[0]);
                this.calendarTestHours2.html(diffHours[1]);

                this.calendarTestMinutes1.html(diffMinutes[0]);
                this.calendarTestMinutes2.html(diffMinutes[1]);

                this.calendarTestSeconds1.html(diffSeconds[0]);
                this.calendarTestSeconds2.html(diffSeconds[1]);

                if (diffDays[0] != 0 || diffDays[1] != 0) {
                    this.calendarTestDays1.show();
                    this.calendarTestDays2.show();
                    this.calendarTestDaysUnit.show();

                    this.calendarTestSeconds1.hide();
                    this.calendarTestSeconds2.hide();
                    this.calendarTestSecondsUnit.hide();
                } else {
                    this.calendarTestDays1.hide();
                    this.calendarTestDays2.hide();
                    this.calendarTestDaysUnit.hide();

                    this.calendarTestSeconds1.show();
                    this.calendarTestSeconds2.show();
                    this.calendarTestSecondsUnit.show();
                }
            }

            this.enable();
        } else {
            this.disable();
        }
    }

    /**
     * Show banner
     */
    enable() {
        this.jQueryElement.addClass("enable").removeClass("disable");
    }

    /**
     * Hide banner
     */
    disable() {
        this.jQueryElement.addClass("disable").removeClass("enable");
    }

    /**
     * @returns {any}
     */
    getHtml(sizeFixed) {
        if (sizeFixed) {
            this.jQueryElement.css('height', '60px');
        }

        return this.jQueryElement;
    }

    /**
     * Rebuild html and reset events
     */
    rebuild() {
        this.clearEvents();
        this.buildHtml();
        this.bindEvents();
    }

    /**
     * Close the flash info
     */
    close() {
        clearInterval(this.interval);
        sessionStorage.setItem(this.closedFlashinfo, '1');
        $(document).trigger('flashinfo-closed');
    }
}